<template>
  <v-col>
    <v-row v-for="(contents, i) in result" :key="contents.uid">
      <v-col cols="10">
        <v-textarea
          dir="auto"
          v-if="contents.type === 'text'"
          v-model="result[i]['content']"
          label="text"
          outlined
        ></v-textarea>
        <div v-if="contents.type === 'pdf'">
          <object
            v-if="contents.content !== ''"
            width="450"
            height="500"
            type="application/pdf"
            :data="contents.content"
          >
            <p>Kunde inte visa pdf</p>
          </object>
          <v-file-input
            @change="uploadPdf(i)"
            @click:clear="deletePdf(i)"
            v-model="imgs[i]"
            accept="document/pdf"
            show-size
            label="ladda up pdf"
            outlined
          ></v-file-input>
        </div>

        <div v-if="contents.type === 'video'">
          <div class="video-container">
            <iframe
              :src="result[i].content"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <v-text-field
            dir="auto"
            v-model="imgs[i]"
            @change="parseYoutube(i)"
            outlined
          ></v-text-field>
        </div>

        <ul v-if="contents.type === 'list'" class="elevation-2 pa-4">
          <li
            v-for="(item, listindex) in contents.content"
            :key="listindex"
            style="list-style:none;"
          >
            <v-row>
              <v-col cols="10">
                <v-text-field
                  dir="auto"
                  v-model="result[i]['content'][listindex]"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn @click="result[i]['content'].splice(i, 1)" icon>
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </li>
          <li style="list-style:none;">
            <v-btn @click="addToList(i)" icon>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </li>
        </ul>

        <div v-if="contents.type === 'img'">
          <v-img v-if="contents.content !== ''" :src="contents.content"></v-img>
          <v-select v-model="contents.content" :items="bucketImgs"> </v-select>
          <v-file-input
            @change="uploadImg(i)"
            @click:clear="deleteImg(i)"
            v-model="imgs[i]"
            accept="image/*"
            show-size
            label="ladda up bild"
            outlined
          ></v-file-input>
        </div>
      </v-col>
      <v-col cols="2">
        <v-btn icon>
          <v-icon v-on:click="removeItem(i)">mdi-minus</v-icon>
        </v-btn>
        <v-btn icon v-if="i > 0" @click="swapDown(i)">
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
        <v-btn icon v-if="result[i + 1]" @click="swapUp(i)">
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="space-around">
      <v-btn @click="addText" icon>
        <v-icon>mdi-text</v-icon>
      </v-btn>
      <v-btn @click="addList" icon>
        <v-icon>mdi-format-list-bulleted</v-icon>
      </v-btn>
      <v-btn @click="addImage" icon>
        <v-icon>mdi-image-plus</v-icon>
      </v-btn>
      <v-btn @click="addVideo" icon>
        <v-icon>mdi-video-plus</v-icon>
      </v-btn>
    </v-row>
  </v-col>
</template>

<script>
import keygen from "@/common/genkey.js";
import { storage } from "@/common/firebase.js";

export default {
  name: "AddContent",
  props: {
    value: Array
  },
  data() {
    return {
      imgs: [],

      bucketImgs: [],
      result: this.value
    };
  },
  methods: {
    addText() {
      this.result.push({
        uid: keygen(),
        type: "pdf",
        content: ""
      });
    },
    addList() {
      this.result.push({
        uid: keygen(),
        type: "list",
        content: [""]
      });
    },
    addImage() {
      this.result.push({
        uid: keygen(),
        type: "img",
        content: ""
      });
    },
    addVideo() {
      this.result.push({
        uid: keygen(),
        type: "video",
        content: ""
      });
    },
    swapUp(index) {
      const currentTemp = this.result[index];
      const nextTemp = this.result[index + 1];
      this.$set(this.result, index, nextTemp);
      this.$set(this.result, index + 1, currentTemp);
    },
    swapDown(index) {
      const currentTemp = this.result[index];
      const nextTemp = this.result[index - 1];
      this.$set(this.result, index, nextTemp);
      this.$set(this.result, index - 1, currentTemp);
    },
    addToList(index) {
      this.result[index].content.push("");
    },
    //Functions for Images (upload get and delete)
    uploadImg(index) {
      if (this.imgs[index]) {
        const ref = storage.ref();
        const imgRef = ref.child(`img/${this.imgs[index].name}`);
        imgRef.put(this.imgs[index]).then(() => {
          imgRef.getDownloadURL().then(url => {
            this.result[index].content = url;
          });
        });
      }
    },
    deleteImg(index) {
      const ref = storage.ref();
      const imgRef = ref.child(`img/${this.imgs[index].name}`);
      imgRef.delete().then(() => {
        if (this.result[index]) {
          this.result[index].content = "";
        }
      });
    },
    removeItem(index) {
      if (this.result[index].type === "img" && this.imgs[index]) {
        this.deleteImg(index);
        this.result.splice(index, 1);
      } else {
        this.result.splice(index, 1);
      }
    },
    getAllImgs() {
      const ref = storage.ref();
      const listRef = ref.child("img");
      listRef.listAll().then(res => {
        res.items.forEach((item, i) => {
          item.getDownloadURL().then(url => {
            this.bucketImgs[i] = { text: item.name, value: url };
          });
        });
      });
    },
    //Functions for documents (upload get and delete)
    uploadPdf(index) {
      const ref = storage.ref();
      const pdfRef = ref.child(`pdf/${this.imgs[index].name}`);
      pdfRef.put(this.imgs[index]).then(() => {
        pdfRef.getDownloadURL().then(url => {
          this.result[index].content = url;
        });
      });
    },
    deletePdf(index) {
      const ref = storage.ref();
      const pdfRef = ref.child(`pdf/${this.imgs[index].name}`);
      pdfRef.delete().then(() => {
        if (this.result[index]) {
          this.result[index].content = "";
        }
      });
    },
    getAllPdfs() {},
    parseYoutube(index) {
      var videoID = this.imgs[index].split("=");
      this.result[index].content =
        "https://www.youtube.com/embed/" + videoID[1];
    }
  },
  watch: {
    result(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.getAllImgs();
  }
};
</script>

<style scoped>
.video-container {
  overflow: hidden;
  position: relative;
  width: 100%;
}

.video-container::after {
  padding-top: 56.25%;
  display: block;
  content: "";
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
